module.exports = __webpack_public_path__ + "img/logo_Anaseguros.a448e420.svg";